import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import BracketTreeView from './BracketTreeView'

/* Consolation Bracket — main single-elim + apart losers-bracket voor de
   R1-verliezers. Beide worden als aparte BracketTreeView getoond. */
export default function ConsolationBracket({ matches, participantHrefs = {}, onMatchClick, isAdmin }) {
  const mainMatches        = matches.filter(m => m.bracket_type === 'main' || !m.bracket_type)
  const consolationMatches = matches.filter(m => m.bracket_type === 'consolation')

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-mono uppercase tracking-widest text-acid">
            Main bracket
          </CardTitle>
        </CardHeader>
        <CardContent>
          <BracketTreeView matches={mainMatches} onMatchClick={onMatchClick} isAdmin={isAdmin}
                           participantHrefs={participantHrefs} />
        </CardContent>
      </Card>

      {consolationMatches.length > 0 && (
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-mono uppercase tracking-widest text-peach">
              Consolation bracket
            </CardTitle>
          </CardHeader>
          <CardContent>
            <BracketTreeView matches={consolationMatches} onMatchClick={onMatchClick} isAdmin={isAdmin} tone="peach"
                             participantHrefs={participantHrefs} />
          </CardContent>
        </Card>
      )}
    </div>
  )
}
